/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AffectedEntitiesResponse,
  CreateRelationshipRequest,
  DiscoverRelationshipsRequest,
  RelationshipListResponse,
  RelationshipResponse,
} from '../models/index';
import {
    AffectedEntitiesResponseFromJSON,
    AffectedEntitiesResponseToJSON,
    CreateRelationshipRequestFromJSON,
    CreateRelationshipRequestToJSON,
    DiscoverRelationshipsRequestFromJSON,
    DiscoverRelationshipsRequestToJSON,
    RelationshipListResponseFromJSON,
    RelationshipListResponseToJSON,
    RelationshipResponseFromJSON,
    RelationshipResponseToJSON,
} from '../models/index';

export interface CreateRelationshipOperationRequest {
    createRelationshipRequest: CreateRelationshipRequest;
    sessionId?: string;
}

export interface DeleteRelationshipRequest {
    relationshipId: string;
    sessionId?: string;
}

export interface DiscoverRelationshipsOperationRequest {
    discoverRelationshipsRequest: DiscoverRelationshipsRequest;
    sessionId?: string;
}

export interface GetContainersHostedByAssetRequest {
    assetId: string;
    sessionId?: string;
}

export interface GetEntitiesAffectedByVulnerabilityRequest {
    vulnerabilityId: string;
    sessionId?: string;
}

export interface GetRelationshipsByTypeRequest {
    relationshipType: string;
    sessionId?: string;
    page?: number;
    pageSize?: number;
}

export interface GetRelationshipsForEntityRequest {
    entityType: string;
    entityId: string;
    sessionId?: string;
    page?: number;
    pageSize?: number;
}

export interface GetSourceRelationshipsRequest {
    entityType: string;
    entityId: string;
    sessionId?: string;
}

export interface GetTargetRelationshipsRequest {
    entityType: string;
    entityId: string;
    sessionId?: string;
}

export interface GetVulnerabilitiesAffectingAssetRequest {
    assetId: string;
    sessionId?: string;
}

/**
 * EntityRelationshipsApi - interface
 * 
 * @export
 * @interface EntityRelationshipsApiInterface
 */
export interface EntityRelationshipsApiInterface {
    /**
     * Creates a relationship between two entities
     * @summary Create a relationship
     * @param {CreateRelationshipRequest} createRelationshipRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    createRelationshipRaw(requestParameters: CreateRelationshipOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipResponse>>;

    /**
     * Creates a relationship between two entities
     * Create a relationship
     */
    createRelationship(requestParameters: CreateRelationshipOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipResponse>;

    /**
     * Soft deletes a relationship (retained for audit/compliance)
     * @summary Delete a relationship
     * @param {string} relationshipId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    deleteRelationshipRaw(requestParameters: DeleteRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Soft deletes a relationship (retained for audit/compliance)
     * Delete a relationship
     */
    deleteRelationship(requestParameters: DeleteRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Extracts and creates relationships from normalized entity data using EntityRelationshipModel
     * @summary Discover relationships from entity data
     * @param {DiscoverRelationshipsRequest} discoverRelationshipsRequest 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    discoverRelationshipsRaw(requestParameters: DiscoverRelationshipsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>>;

    /**
     * Extracts and creates relationships from normalized entity data using EntityRelationshipModel
     * Discover relationships from entity data
     */
    discoverRelationships(requestParameters: DiscoverRelationshipsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse>;

    /**
     * Retrieves all containers that are hosted by the specified asset
     * @summary Get containers hosted by an asset
     * @param {string} assetId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    getContainersHostedByAssetRaw(requestParameters: GetContainersHostedByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedEntitiesResponse>>;

    /**
     * Retrieves all containers that are hosted by the specified asset
     * Get containers hosted by an asset
     */
    getContainersHostedByAsset(requestParameters: GetContainersHostedByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedEntitiesResponse>;

    /**
     * Retrieves all assets and containers that have the specified vulnerability
     * @summary Get entities affected by a vulnerability
     * @param {string} vulnerabilityId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    getEntitiesAffectedByVulnerabilityRaw(requestParameters: GetEntitiesAffectedByVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedEntitiesResponse>>;

    /**
     * Retrieves all assets and containers that have the specified vulnerability
     * Get entities affected by a vulnerability
     */
    getEntitiesAffectedByVulnerability(requestParameters: GetEntitiesAffectedByVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedEntitiesResponse>;

    /**
     * Retrieves all relationships of a specific type (e.g., HOSTS, HAS_VULNERABILITY)
     * @summary Get relationships by type
     * @param {string} relationshipType 
     * @param {string} [sessionId] 
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    getRelationshipsByTypeRaw(requestParameters: GetRelationshipsByTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>>;

    /**
     * Retrieves all relationships of a specific type (e.g., HOSTS, HAS_VULNERABILITY)
     * Get relationships by type
     */
    getRelationshipsByType(requestParameters: GetRelationshipsByTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse>;

    /**
     * Retrieves all relationships where the entity is either the source or target
     * @summary Get all relationships for an entity
     * @param {string} entityType Entity type (ASSET, CONTAINER, VULNERABILITY, USER, etc.)
     * @param {string} entityId Entity ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {number} [page] Page number (default: 1)
     * @param {number} [pageSize] Page size (default: 50)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    getRelationshipsForEntityRaw(requestParameters: GetRelationshipsForEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>>;

    /**
     * Retrieves all relationships where the entity is either the source or target
     * Get all relationships for an entity
     */
    getRelationshipsForEntity(requestParameters: GetRelationshipsForEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse>;

    /**
     * Retrieves relationships where the entity is the source (e.g., Asset HOSTS Container)
     * @summary Get source relationships for an entity
     * @param {string} entityType 
     * @param {string} entityId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    getSourceRelationshipsRaw(requestParameters: GetSourceRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>>;

    /**
     * Retrieves relationships where the entity is the source (e.g., Asset HOSTS Container)
     * Get source relationships for an entity
     */
    getSourceRelationships(requestParameters: GetSourceRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse>;

    /**
     * Retrieves relationships where the entity is the target (e.g., Container HOSTED_BY Asset)
     * @summary Get target relationships for an entity
     * @param {string} entityType 
     * @param {string} entityId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    getTargetRelationshipsRaw(requestParameters: GetTargetRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>>;

    /**
     * Retrieves relationships where the entity is the target (e.g., Container HOSTED_BY Asset)
     * Get target relationships for an entity
     */
    getTargetRelationships(requestParameters: GetTargetRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse>;

    /**
     * Retrieves all vulnerabilities that affect the specified asset
     * @summary Get vulnerabilities affecting an asset
     * @param {string} assetId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityRelationshipsApiInterface
     */
    getVulnerabilitiesAffectingAssetRaw(requestParameters: GetVulnerabilitiesAffectingAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedEntitiesResponse>>;

    /**
     * Retrieves all vulnerabilities that affect the specified asset
     * Get vulnerabilities affecting an asset
     */
    getVulnerabilitiesAffectingAsset(requestParameters: GetVulnerabilitiesAffectingAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedEntitiesResponse>;

}

/**
 * 
 */
export class EntityRelationshipsApi extends runtime.BaseAPI implements EntityRelationshipsApiInterface {

    /**
     * Creates a relationship between two entities
     * Create a relationship
     */
    async createRelationshipRaw(requestParameters: CreateRelationshipOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipResponse>> {
        if (requestParameters['createRelationshipRequest'] == null) {
            throw new runtime.RequiredError(
                'createRelationshipRequest',
                'Required parameter "createRelationshipRequest" was null or undefined when calling createRelationship().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/relationships`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRelationshipRequestToJSON(requestParameters['createRelationshipRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipResponseFromJSON(jsonValue));
    }

    /**
     * Creates a relationship between two entities
     * Create a relationship
     */
    async createRelationship(requestParameters: CreateRelationshipOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipResponse> {
        const response = await this.createRelationshipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Soft deletes a relationship (retained for audit/compliance)
     * Delete a relationship
     */
    async deleteRelationshipRaw(requestParameters: DeleteRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['relationshipId'] == null) {
            throw new runtime.RequiredError(
                'relationshipId',
                'Required parameter "relationshipId" was null or undefined when calling deleteRelationship().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/relationships/{relationshipId}`;
        urlPath = urlPath.replace(`{${"relationshipId"}}`, encodeURIComponent(String(requestParameters['relationshipId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Soft deletes a relationship (retained for audit/compliance)
     * Delete a relationship
     */
    async deleteRelationship(requestParameters: DeleteRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteRelationshipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Extracts and creates relationships from normalized entity data using EntityRelationshipModel
     * Discover relationships from entity data
     */
    async discoverRelationshipsRaw(requestParameters: DiscoverRelationshipsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>> {
        if (requestParameters['discoverRelationshipsRequest'] == null) {
            throw new runtime.RequiredError(
                'discoverRelationshipsRequest',
                'Required parameter "discoverRelationshipsRequest" was null or undefined when calling discoverRelationships().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/mdm/relationships/discover`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DiscoverRelationshipsRequestToJSON(requestParameters['discoverRelationshipsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipListResponseFromJSON(jsonValue));
    }

    /**
     * Extracts and creates relationships from normalized entity data using EntityRelationshipModel
     * Discover relationships from entity data
     */
    async discoverRelationships(requestParameters: DiscoverRelationshipsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse> {
        const response = await this.discoverRelationshipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all containers that are hosted by the specified asset
     * Get containers hosted by an asset
     */
    async getContainersHostedByAssetRaw(requestParameters: GetContainersHostedByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedEntitiesResponse>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling getContainersHostedByAsset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/relationships/asset/{assetId}/containers`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AffectedEntitiesResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all containers that are hosted by the specified asset
     * Get containers hosted by an asset
     */
    async getContainersHostedByAsset(requestParameters: GetContainersHostedByAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedEntitiesResponse> {
        const response = await this.getContainersHostedByAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all assets and containers that have the specified vulnerability
     * Get entities affected by a vulnerability
     */
    async getEntitiesAffectedByVulnerabilityRaw(requestParameters: GetEntitiesAffectedByVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedEntitiesResponse>> {
        if (requestParameters['vulnerabilityId'] == null) {
            throw new runtime.RequiredError(
                'vulnerabilityId',
                'Required parameter "vulnerabilityId" was null or undefined when calling getEntitiesAffectedByVulnerability().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/relationships/vulnerability/{vulnerabilityId}/affected-entities`;
        urlPath = urlPath.replace(`{${"vulnerabilityId"}}`, encodeURIComponent(String(requestParameters['vulnerabilityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AffectedEntitiesResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all assets and containers that have the specified vulnerability
     * Get entities affected by a vulnerability
     */
    async getEntitiesAffectedByVulnerability(requestParameters: GetEntitiesAffectedByVulnerabilityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedEntitiesResponse> {
        const response = await this.getEntitiesAffectedByVulnerabilityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all relationships of a specific type (e.g., HOSTS, HAS_VULNERABILITY)
     * Get relationships by type
     */
    async getRelationshipsByTypeRaw(requestParameters: GetRelationshipsByTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>> {
        if (requestParameters['relationshipType'] == null) {
            throw new runtime.RequiredError(
                'relationshipType',
                'Required parameter "relationshipType" was null or undefined when calling getRelationshipsByType().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/relationships/type/{relationshipType}`;
        urlPath = urlPath.replace(`{${"relationshipType"}}`, encodeURIComponent(String(requestParameters['relationshipType'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all relationships of a specific type (e.g., HOSTS, HAS_VULNERABILITY)
     * Get relationships by type
     */
    async getRelationshipsByType(requestParameters: GetRelationshipsByTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse> {
        const response = await this.getRelationshipsByTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all relationships where the entity is either the source or target
     * Get all relationships for an entity
     */
    async getRelationshipsForEntityRaw(requestParameters: GetRelationshipsForEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getRelationshipsForEntity().'
            );
        }

        if (requestParameters['entityId'] == null) {
            throw new runtime.RequiredError(
                'entityId',
                'Required parameter "entityId" was null or undefined when calling getRelationshipsForEntity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/relationships/entity/{entityType}/{entityId}`;
        urlPath = urlPath.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType'])));
        urlPath = urlPath.replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters['entityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all relationships where the entity is either the source or target
     * Get all relationships for an entity
     */
    async getRelationshipsForEntity(requestParameters: GetRelationshipsForEntityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse> {
        const response = await this.getRelationshipsForEntityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves relationships where the entity is the source (e.g., Asset HOSTS Container)
     * Get source relationships for an entity
     */
    async getSourceRelationshipsRaw(requestParameters: GetSourceRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getSourceRelationships().'
            );
        }

        if (requestParameters['entityId'] == null) {
            throw new runtime.RequiredError(
                'entityId',
                'Required parameter "entityId" was null or undefined when calling getSourceRelationships().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/relationships/entity/{entityType}/{entityId}/source`;
        urlPath = urlPath.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType'])));
        urlPath = urlPath.replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters['entityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves relationships where the entity is the source (e.g., Asset HOSTS Container)
     * Get source relationships for an entity
     */
    async getSourceRelationships(requestParameters: GetSourceRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse> {
        const response = await this.getSourceRelationshipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves relationships where the entity is the target (e.g., Container HOSTED_BY Asset)
     * Get target relationships for an entity
     */
    async getTargetRelationshipsRaw(requestParameters: GetTargetRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RelationshipListResponse>> {
        if (requestParameters['entityType'] == null) {
            throw new runtime.RequiredError(
                'entityType',
                'Required parameter "entityType" was null or undefined when calling getTargetRelationships().'
            );
        }

        if (requestParameters['entityId'] == null) {
            throw new runtime.RequiredError(
                'entityId',
                'Required parameter "entityId" was null or undefined when calling getTargetRelationships().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/relationships/entity/{entityType}/{entityId}/target`;
        urlPath = urlPath.replace(`{${"entityType"}}`, encodeURIComponent(String(requestParameters['entityType'])));
        urlPath = urlPath.replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters['entityId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RelationshipListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves relationships where the entity is the target (e.g., Container HOSTED_BY Asset)
     * Get target relationships for an entity
     */
    async getTargetRelationships(requestParameters: GetTargetRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RelationshipListResponse> {
        const response = await this.getTargetRelationshipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all vulnerabilities that affect the specified asset
     * Get vulnerabilities affecting an asset
     */
    async getVulnerabilitiesAffectingAssetRaw(requestParameters: GetVulnerabilitiesAffectingAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AffectedEntitiesResponse>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling getVulnerabilitiesAffectingAsset().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/mdm/relationships/asset/{assetId}/vulnerabilities`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AffectedEntitiesResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all vulnerabilities that affect the specified asset
     * Get vulnerabilities affecting an asset
     */
    async getVulnerabilitiesAffectingAsset(requestParameters: GetVulnerabilitiesAffectingAssetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AffectedEntitiesResponse> {
        const response = await this.getVulnerabilitiesAffectingAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
